import { getApiBaseUrl } from 'api';
import { Access } from 'types/types';

export const masterAuthUrl = (access: Access) =>
  `${getApiBaseUrl(access)}/web/masterAuth`;
